import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import firebase from "firebase";

Vue.config.productionTip = false

firebase.initializeApp({
  apiKey: "AIzaSyAGd412RQ_ixL8D9kJ3bgzLuAeN62NdpIM",
  authDomain: "samdev-ae591.firebaseapp.com",
  databaseURL: "https://samdev-ae591.firebaseio.com",
  projectId: "samdev-ae591",
  storageBucket: "samdev-ae591.appspot.com",
  messagingSenderId: "1071534531516",
  appId: "1:1071534531516:web:3900e8009b472efe0281b9",
  measurementId: "G-Z8N8LG16NR"
});
export const db = firebase.firestore();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')